import { MeshEdgesMode } from '../../../../main/modelViewers/components/content/ModelViewerEditor/hooks/useModelViewerMeshEdges';
import { useModelViewerMeshEdgesHelper } from './hooks/useModelViewerMeshEdgesHelper';

interface ModelViewerMeshEdgesHelperProps {
  mode: MeshEdgesMode;
}

function ModelViewerMeshEdgesHelper({ mode }: ModelViewerMeshEdgesHelperProps) {
  useModelViewerMeshEdgesHelper({ mode });

  return null;
}

export default ModelViewerMeshEdgesHelper;
